import React from 'react'
import './Footer.css'
const Footer = () => {
  return (
    <div className='footer'>
      &copy; 2024 SENMOSDEV Portfolio
    </div>
  )
}

export default Footer
